export type TPageInfo = {
    date: string;
    id: string;
};

export const isClient = typeof window !== 'undefined';

export const PAGES_HISTORY = 'ViewedPagesHistory';
export const SHOW_TIME = 'showTime';

export const getValueFromLocalStorage = (key: string, defaultvalue: string) =>
    isClient ? JSON.parse(localStorage.getItem(key) || defaultvalue) : defaultvalue;

export const setValueToLocalStorage = (key: string, value: number | TPageInfo[]) => {
    if (isClient) {
        localStorage.setItem(key, JSON.stringify(value));
    }
};
